<template>
    <div class="waiverScroll">
        <div class="ma-5" id="waiverSignForm">
            <v-row v-if="bandResult">
                    <v-col cols="8" class="mx-auto mt-15">
                        <v-alert
                            border="bottom"
                            outlined
                            type="success"
                            class="msgBigAlert"
                        >
                            <div class="text-h6 d-block" style="color: black;">
                                {{$t("waiver_sign.save_success")}} <br />
                                {{$t("waiver_sign.thank_livelaps")}}
                            </div>
                        </v-alert>
                    </v-col>
            </v-row>
            <v-row v-else>
                <v-col cols="12" class="mb-10">
                    <v-row>
                        <v-col cols="12" sm="8" class="mx-auto mt-6">
                            <p v-if="type == 'Adult'" class="text-h6">
                                <template v-if="firstName && lastName">
                                    {{$t("waiver_sign.title_waiver_name", language, { firstName, lastName })}}<br />
                                    <p>{{$t("waiver_sign.sub_title_adult", language)}}</p>
                                </template>
                                <template v-else>
                                    {{$t("waiver_sign.title_waiver", language)}}<br />
                                    <p>{{$t("waiver_sign.sub_title_adult", language)}}</p>
                                </template>
                            </p>
                            <p v-else class="text-h6">
                                <template v-if="firstNameMinor && lastNameMinor">
                                    {{$t("waiver_sign.title_waiver_name", language, { firstName: firstNameMinor, lastName: lastNameMinor })}} <br />
                                    <p>{{$t("waiver_sign.sub_title_minor", language)}}</p>
                                </template> 
                                <template v-else>
                                    {{$t("waiver_sign.title_waiver", language)}} <br />
                                    <p>{{$t("waiver_sign.sub_title_minor", language)}}</p>
                                </template>       
                            </p>
                        </v-col>
                    </v-row>
                    <v-row class="headerTitle">
                        <v-col cols="10" class="mx-auto printSpace">
                            <v-row>
                                <v-col cols="12" md="4" sm="5" v-if="hasImage">
                                <v-img
                                    width="60%"
                                    :src="imageUrl"
                                    style="max-height: 180px;"
                                    class="mx-auto"
                                    @error="processErrorImg"
                                > </v-img>
                            </v-col>
                            <v-col cols="12" :md="hasImage ? 8 : 12" :sm="hasImage ? 7 : 12" class="waiverTitle">
                                <span class="font-weight-bold">{{waiverTitle}}</span>
                            </v-col>
                            </v-row >
                            <v-form ref="formWaiver">
                                <v-card outlined class="pa-4 mt-4">
                                    <p v-if="statusWaiver == 'NotSigned'" class="text-left">
                                        <span  class="font-weight-bold">{{$t("waiver_sign.current_ip_address", language)}}:</span> {{currentIp}} {{currentTimeStamp}}
                                    </p>
                                    <p v-else class="text-left">
                                        <span class="font-weight-bold">{{$t("waiver_sign.current_ip_address", language)}}:</span> {{ipAddress}}
                                    </p>
                                </v-card>
                                <v-card outlined class="pa-4 mt-4">
                                    <p class="text-left">
                                        <span >{{$tc("common.eventName", language)}}:</span> <span class="font-weight-bold">{{$escapeHtml.decode(eventName)}}</span><br />
                                        <span >{{$tc("common.event_start_date", language)}}:</span> <span class="font-weight-bold">{{eventStartDate}}</span> <br />
                                        <span >{{$tc("common.event_end_date", language)}}:</span> <span class="font-weight-bold">{{eventEndDate}}</span>
                                    </p>
                                </v-card>
                                <v-card outlined class="pa-4 mt-4">
                                    <p class="text-left" v-html="waiverText"></p>
                                    <v-checkbox
                                        ref="iAgree"
                                        v-model="iAgree"
                                        :label="timeIAgreeLabel"
                                        :rules="iAgreeRules"
                                        :disabled="statusWaiver == 'Rejected' ? true : false"
                                        :readonly="disabledOptions"
                                    ></v-checkbox>
                                </v-card>
                                <v-card v-if="!isLegacySigned" outlined class="pa-4 mt-4" ref="isNegligenceContent">
                                    <p>{{ negligenceParagraph }}</p>
                                    <v-checkbox
                                        ref="isNegligence"
                                        v-model="isNegligence"
                                        :label="timeIsNegligenceLabel"
                                        :rules="isNegligenceRules"
                                        :disabled="statusWaiver == 'Rejected' ? true : false"
                                        :readonly="disabledOptions"
                                    ></v-checkbox>
                                </v-card>
                                <v-card v-if="type == 'Minor'" outlined class="pa-4 mt-4">
                                    <p class="text-subtitle-1 font-weight-bold text-left">{{$t("waiver_sign.minor_information", language)}}</p>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field
                                                ref="firstNameMinor"
                                                v-model="firstNameMinor"
                                                :label="$t('common.firstName', language)"
                                                :rules="firstNameRules"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                ref="lastNameMinor"
                                                v-model="lastNameMinor"
                                                :label="$t('common.lastName', language)"
                                                :rules="lastNameRules"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-select
                                                ref="genderMinor"
                                                :items="genders"
                                                v-model="genderMinor"
                                                :label="$t('common.gender', language)"
                                                :rules="genderRules"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12">
                                            <p class="text-subtitle-1 font-weight-bold">{{$t("waiver_sign.your_date_of_birth")}}</p>
                                            <v-row>
                                                <v-col sm="4" cols="12">
                                                    <v-combobox
                                                        ref="yearMinor"
                                                        :items="years"
                                                        label="Year"
                                                        dense outlined attach
                                                        :rules="yearRules"
                                                        v-model="yearMinor"
                                                        :readonly="bandReadOnly"
                                                        @change="changeAge('Minor')"
                                                        :menu-props="{ top: true, offsetY: true, contentClass: 'heigthLimit' }"
                                                    ></v-combobox>
                                                </v-col>
                                                <v-col sm="4" cols="12">
                                                    <v-select
                                                        ref="monthMinor"
                                                        :items="months"
                                                        label="Month"
                                                        dense outlined attach
                                                        :rules="monthRules"
                                                        v-model="monthMinor"
                                                        :readonly="bandReadOnly"
                                                        @change="changeAge('Minor')"
                                                        :menu-props="{ top: true, offsetY: true, contentClass: 'heigthLimit' }"
                                                    ></v-select>
                                                </v-col>
                                                <v-col sm="4" cols="12">
                                                    <v-combobox
                                                        ref="dayMinor"
                                                        :items="days"
                                                        label="Day"
                                                        dense outlined attach
                                                        :rules="dayRules"
                                                        v-model="dayMinor"
                                                        :readonly="bandReadOnly"
                                                        cache-items
                                                        @change="changeAge('Minor')"
                                                        :menu-props="{ top: true, offsetY: true, contentClass: 'heigthLimit' }"
                                                    ></v-combobox>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-card outlined class="pa-4 mt-4 pagebreak">
                                    <p v-if="type == 'Adult'" class="text-subtitle-1 font-weight-bold text-left">{{$t("waiver_sign.your_information", language)}}</p>
                                    <p v-else class="text-subtitle-1 font-weight-bold text-left">{{$t("waiver_sign.parent_information", language)}}</p>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field
                                                v-if="type == 'Adult'"
                                                ref="firstName"
                                                v-model="firstName"
                                                :label="$t('common.firstName', language)"
                                                :rules="firstNameRules"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-text-field>
                                            <v-text-field
                                                v-else
                                                ref="firstNameParent"
                                                v-model="firstNameParent"
                                                :label="$t('common.firstName', language)"
                                                :rules="firstNameRules"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                v-if="type == 'Adult'"
                                                ref="lastName"
                                                v-model="lastName"
                                                :label="$t('common.lastName', language)"
                                                :rules="lastNameRules"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-text-field>
                                            <v-text-field
                                                v-else
                                                ref="lastNameParent"
                                                v-model="lastNameParent"
                                                :label="$t('common.lastName', language)"
                                                :rules="lastNameRules"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-select
                                                v-if="type == 'Adult'"
                                                ref="gender"
                                                :items="genders"
                                                v-model="gender"
                                                :label="$t('common.gender', language)"
                                                :rules="genderRules"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-select>
                                            <v-select
                                                v-else
                                                ref="genderParent"
                                                :items="genders"
                                                v-model="genderParent"
                                                :label="$t('common.gender', language)"
                                                :rules="genderRules"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                v-if="type == 'Adult'"
                                                ref="email"
                                                v-model="email"
                                                :label="$t('common.email', language)"
                                                :rules="emailRules"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-text-field>
                                            <v-text-field
                                                v-else
                                                ref="emailParent"
                                                v-model="emailParent"
                                                :label="$t('common.email', language)"
                                                :rules="emailRules"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                v-if="type == 'Adult'"
                                                ref="phone"
                                                v-model="phone"
                                                @input="onPhoneInput('phone', $event)"
                                                :label="$t('common.phone', language)"
                                                :rules="phoneRules"
                                                maxlength="12"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-text-field>
                                            <v-text-field
                                                v-else
                                                ref="phoneParent"
                                                v-model="phoneParent"
                                                @input="onPhoneInput('phoneParent', $event)"
                                                :label="$t('common.phone', language)"
                                                :rules="phoneRules"
                                                maxlength="12"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                v-if="type == 'Adult'"
                                                ref="address"
                                                v-model="address"
                                                :label="$t('common.address', language)"
                                                :rules="addressRules"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-text-field>
                                            <v-text-field
                                                v-else
                                                ref="addressParent"
                                                v-model="addressParent"
                                                :label="$t('common.address', language)"
                                                :rules="addressRules"
                                                outlined dense
                                                :readonly="bandReadOnly"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <p class="text-subtitle-1 font-weight-bold text-left">{{$t("waiver_sign.your_date_of_birth", language)}}</p>
                                            <v-row>
                                                <v-col sm="4" cols="12">
                                                    <v-combobox
                                                        v-if="type == 'Adult'"
                                                        ref="year"
                                                        :items="years"
                                                        label="Year"
                                                        dense outlined attach 
                                                        :rules="yearRules"
                                                        v-model="year"
                                                        :readonly="bandReadOnly"
                                                        @change="changeAge('Adult')"
                                                        :menu-props="{ top: true, offsetY: true, contentClass: 'heigthLimit' }"
                                                    ></v-combobox>
                                                    <v-combobox
                                                        v-else
                                                        ref="yearParent"
                                                        :items="years"
                                                        label="Year"
                                                        dense outlined attach
                                                        :rules="yearRules"
                                                        v-model="yearParent"
                                                        :readonly="bandReadOnly"
                                                        @change="changeAge('Parent')"
                                                        :menu-props="{ top: true, offsetY: true, contentClass: 'heigthLimit' }"
                                                    ></v-combobox>
                                                </v-col>
                                                <v-col sm="4" cols="12">
                                                    <v-select
                                                        v-if="type == 'Adult'"
                                                        ref="month"
                                                        :items="months"
                                                        label="Month"
                                                        dense outlined attach
                                                        :rules="monthRules"
                                                        v-model="month"
                                                        :readonly="bandReadOnly"
                                                        @change="changeAge('Adult')"
                                                        :menu-props="{ top: true, offsetY: true, contentClass: 'heigthLimit' }"
                                                    ></v-select>
                                                    <v-select
                                                        v-else
                                                        ref="monthParent"
                                                        :items="months"
                                                        label="Month"
                                                        dense outlined attach
                                                        :rules="monthRules"
                                                        v-model="monthParent"
                                                        :readonly="bandReadOnly"
                                                        @change="changeAge('Parent')" 
                                                        :menu-props="{ top: true, offsetY: true, contentClass: 'heigthLimit' }"
                                                    ></v-select>
                                                </v-col>
                                                <v-col sm="4" cols="12">
                                                    <v-combobox
                                                        v-if="type == 'Adult'"
                                                        ref="day"
                                                        :items="days"
                                                        label="Day"
                                                        dense outlined attach
                                                        :rules="dayRules"
                                                        v-model="day"
                                                        :readonly="bandReadOnly"
                                                        cache-items
                                                        @change="changeAge('Adult')"
                                                        :menu-props="{ top: true, offsetY: true, contentClass: 'heigthLimit'}"
                                                    ></v-combobox>
                                                    <v-combobox
                                                        v-else
                                                        ref="dayParent"
                                                        :items="days"
                                                        label="Day"
                                                        dense outlined attach
                                                        :rules="dayRules"
                                                        v-model="dayParent"
                                                        :readonly="bandReadOnly"
                                                        cache-items
                                                        @change="changeAge('Parent')"
                                                        :menu-props="{ top: true, offsetY: true, contentClass: 'heigthLimit' }"
                                                    ></v-combobox>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12">
                                            {{$t("common.phone",language)}}: <span class="font-weight-bold">{{ waiver && waiver.signatoryPhone ? waiver.signatoryPhone : '' }}</span><br />
                                            {{$t("common.address",language)}}: <span class="font-weight-bold">{{ waiver && waiver.signatoryAddress ? waiver.signatoryAddress : '' }}</span><br />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-checkbox
                                                ref="isCorrect"
                                                v-model="isCorrect"
                                                :label="timeIsCorrectLabel"
                                                class="ml-4"
                                                :rules="isCorrectRules"
                                                :readonly="disabledOptions"
                                            ></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-card v-if="!isLegacySigned" outlined class="pa-4 mt-4 pagebreak" ref="isBoundParticipantContent">
                                    <p>{{ boundAgreementParagraph }}</p>
                                    <p class="mb-0" style="border-bottom:1px solid #000;padding-bottom:4px;">
                                        <span class="font-weight-bold">
                                            {{ type === 'Minor'
                                                ? `${firstNameMinor || ''} ${lastNameMinor || ''}`.trim()
                                                : `${firstName || ''} ${lastName || ''}`.trim() }}
                                        </span>
                                    </p>
                                    <p class="text-caption mt-0">{{$t("waiver_sign.name_of_participant",language)}}</p>
                                    <v-checkbox
                                        ref="isBoundParticipant"
                                        v-model="isBoundParticipant"
                                        :label="timeIsBoundParticipantLabel"
                                        :rules="isBoundParticipantRules"
                                        :disabled="statusWaiver == 'Rejected' ? true : false"
                                        :readonly="disabledOptions"
                                    ></v-checkbox>
                                    <template v-if="type === 'Minor'">
                                        <p class="mb-0 mt-4" style="border-bottom:1px solid #000;padding-bottom:4px;">
                                            <span class="font-weight-bold">{{ `${firstName || ''} ${lastName || ''}`.trim() }}</span>
                                        </p>
                                        <p class="text-caption mt-0">{{$t("waiver_sign.name_of_parent",language)}}</p>
                                        <v-checkbox
                                            ref="isBoundParent"
                                            v-model="isBoundParent"
                                            :label="timeIsBoundParentLabel"
                                            :rules="isBoundParentRules"
                                            :disabled="statusWaiver == 'Rejected' ? true : false"
                                            :readonly="disabledOptions"
                                        ></v-checkbox>
                                    </template>
                                </v-card>
                                <v-card outlined class="pa-4 mt-4 pagebreak">
                                    <p class="text-subtitle-1 font-weight-bold text-left">{{$t("waiver_sign.electronic_signature_consent", language)}}</p>
                                    <p v-html="waiverElectronicConsent" class="text-left" tyle="margin: 1%;"></p>
                                    <v-checkbox
                                        ref="isConsent"
                                        v-model="isConsent"
                                        :label="timeIsConsentLabel"
                                        :rules="isConsentRules"
                                        :disabled="statusWaiver == 'Rejected' ? true : false"
                                        :readonly="disabledOptions"
                                    ></v-checkbox>
                                </v-card>
                                <v-card outlined class="pa-4 mt-4 pagebreak">
                                    <v-row>
                                        <v-col cols="12">
                                            <div class="d-flex">
                                                <v-btn v-if="statusWaiver!='Rejected'" color="primary" class="white--text mr-auto" @click="openAddSignature" :disabled="disabledOptions">
                                                    {{$t("waiver_sign.click_to_sign", language)}}
                                                </v-btn>
                                            </div>
                                            <v-card outlined id="signature" :class="`my-4 ${ hasErrorSignature ? 'errorSignature' : '' }`">
                                                <v-card-title class="py-1">{{$t("waiver_sign.signature", language)}}</v-card-title>
                                                <v-divider></v-divider>
                                                <v-card-text :class="{ 'd-flex': !signature }">
                                                    <v-col cols="12" md="12" style="text-align:center;">
                                                        <img :src="signature" height="150" style="margin: 0 auto;">
                                                    </v-col>
                                                    <p class="text-left">{{timeSignature}}</p>
                                                </v-card-text>
                                                <v-divider></v-divider>
                                                <v-card-actions><br /></v-card-actions>
                                            </v-card>
                                            <p v-if="!isLegacySigned" class="font-weight-bold text-center mt-2">
                                                {{$t("waiver_sign.voluntarily_text",language)}}
                                            </p>
                                            <p v-if="hasErrorSignature" class="textErrorSignature text-caption text-left">{{$t("waiver_sign.is_signature_required", language)}}</p>
                                            <div class="d-flex">
                                                <v-btn v-if="!bandReadonly && waiver && !waiver.isPictureRequired" color="primary" @click="submit" class="white--text ml-auto" :disabled="disabledOptions">
                                                    {{$t('common.save', language)}}
                                                </v-btn>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-card outlined class="pa-4 mt-4 pagebreak" v-if="waiver && waiver.isPictureRequired">
                                    <v-row>
                                        <v-col cols="12">
                                            <p class="text-subtitle-1 font-weight-bold text-left">{{$t("waiver_sign.selfie", language)}}</p> 
                                            <p class="text-left">{{ $t('waiver_sign.selfie_description') }}</p>
                                            <div :class="`containImg ${ hasErrorSelfie ? 'errorSelfie' : '' }`">
                                                <img class="imgAvatar" @error="loadPlaceholder" :src="uploadImage_" />
                                                <p v-if="hasErrorSelfie" class="textErrorSelfie text-caption mb-0">{{ $t('waiver_sign.selfie_required') }}</p>
                                            </div>
                                            <div class="d-flex">
                                                <v-btn color="primary" class="white--text btnAvatar" :disabled="disabledOptions" @click="takeSelfie">
                                                    {{$t("waiver_sign.take_selfie", language)}}
                                                </v-btn>
                                                <v-btn v-if="!bandReadonly" color="primary" @click="submit" class="white--text ml-auto" :disabled="disabledOptions">
                                                    {{$t('common.save', language)}}
                                                </v-btn>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-form>
                        </v-col>
                    </v-row>
                    <v-dialog v-model="dialogSignature" max-width="900px">
                            <v-card>
                                <v-card-title>
                                    <span class="headLine">{{$t("waiver_sign.signature", language)}}</span>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="text--primary d-flex" style="min-height: 250px">
                                    <DrawSignature ref="signature" @getImage="getImage" @changeBandSignature="changeBandSignature" />
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn text @click="dialogSignature = false" class="mx-1">{{$tc("common.cancel", language)}}</v-btn>
                                    <v-btn color="primary" class="white--text mx-1" @click="clearSignature()">
                                        {{$tc("common.reset", language)}}
                                    </v-btn>
                                    <v-btn 
                                        color="primary"
                                        class="mx-1" 
                                        @click="saveSignature()" 
                                        :disabled="disabledSignature"
                                    >
                                        {{$tc("common.acept", language)}}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogSelfie" width="430">
                        <v-card class="mx-auto" v-if="typeSelfie == 'selfie' && !bandCropper">
                            <v-card-text style="padding: 12px; display: flex;">
                                <div v-if="!showCam">
                                    <v-alert border="right" colored-border type="error" elevation="2">
                                        {{ $t('waiver_sign.web_cam.error.title') }}
                                    </v-alert>
                                    <p class="black--text mt-3 text-left">{{ $t('waiver_sign.web_cam.error.text_1') }}</p>
                                    <p class="black--text text-left">{{ $t('waiver_sign.web_cam.error.text_2') }}</p>
                                </div>
                                <video
                                    ref="webcam"
                                    v-if="showCam"
                                    width="360" height="380"
                                    style="max-width:100%; border:1px #000 solid; margin: 0 15px;"
                                    autoplay
                                ></video>
                                <canvas
                                    ref="webcam_canvas"
                                    data-type="profile"
                                    width="360" height="480"
                                    style="border:1px #000 solid;display:none;"
                                ></canvas>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="blue-grey"
                                    class="ma-2 white--text"
                                    @click="dialogSelfie = false"
                                >{{ $t("common.form.cancel", language) }}</v-btn>
                                <v-btn
                                    color="blue-grey"
                                    class="ma-2 white--text"
                                    @click="submitSelfie"
                                >{{ $t("common.save", language) }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
            <v-snackbar v-model="snack" timeout="6000" :color="color_snack">{{ msg_snack }}</v-snackbar>
        </div>
    </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import DrawSignature from "@/components/waivers/DrawSignature";
import axios from "axios";

export default {
    mixins: [apiCalls], 
    components: {
        DrawSignature
    },
    data() {
        return {
            title: '',
            statusWaiver: 'NotSigned',
            currentIp: '0.0.0.0',
            currentTimeStamp: '',
            documentSecurity: 'Not Available',
            eventName: '',
            eventStartDate: '', 
            eventEndDate: '',
            text: '',
            iAgree: false,
            timeIAgree: null,
            disabledOptions: false,
            firstNameMinor: null,
            lastNameMinor: null,
            genderMinor: null,
            type: 'Adult',
            electronicConsent: "",
            months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
            bandReadOnly: false,
            year: null,
            month: null,
            day: null,
            yearMinor: null,
            monthMinor: null,
            dayMinor: null,
            firstName: null,
            lastName: null,
            gender: null,
            isConsent: null,
            bandReadonly: false,
            timeIsConsent: null, 
            hasErrorSignature: false,
            timeSignature: null,
            signature: null,
            years: [],
            age18: true,
            dialogSignature: false,
            snack: false,
            color_snack: 'error',
            msg_snack: '',
            disabledSignature: false,
            errorSignature: false,
            firstNameParent: null,
            lastNameParent: null,
            genderParent: null,
            yearParent: null,
            monthParent: null,
            dayParent: null,
            ips: [],
            isCorrect: null,
            timeIsCorrect: null,
            bandResult: false,
            waiver: null,
            waiverStatusStatic: ["Signed","Rejected"],
            urlImage: '',
            dialogSelfie: false,
            showCam: false,
            dataURI: require("@/assets/images/partPlaceholder.jpg"),
            errorImage: require("@/assets/images/partPlaceholder.jpg"),
            showCamG: false,
            typeSelfie: 'selfie',
            bandCropper: false,
            imgSrc: null,
            cropImg: null,
            uploadImage_: require("@/assets/images/partPlaceholder.jpg"),
            fileName: '',
            fileImage: null,
            hasErrorSelfie: false,
            selfie: null,
            isNegligence: false,       timeIsNegligence: "",
            isBoundParticipant: false, timeIsBoundParticipant: "",
            isBoundParent: false,      timeIsBoundParent: "",
            email: "",
            phone: "",
            address: "",
            emailParent: "",
            phoneParent: "",
            addressParent: "",
        };
    },
    computed: {
        iAgreeRules() {
            return [
                (val) => val || this.$t("waiver_sign.i_agree_required")
            ]
        },
        genders() {
            const genders = [
                {value: 'male', text: this.$t("common.male")},
                {value: 'female', text: this.$t("common.female")},
                {value: 'other', text: this.$t("common.other")}
            ];
            return genders;
        },
        firstNameRules() {
            return [
                (val) => (val || "").length > 0 || this.$t("waiver_sign.first_name_required")
            ];
        },
        lastNameRules() {
            return [
                (val) => (val || "").length > 0 || this.$t("waiver_sign.last_name_required")
            ];
        },
        genderRules() {
            return [
                (val) => (val || "").length > 0 || this.$t("waiver_sign.gender_required")
            ];
        },
        emailRules() {
            return [
                (val) => (val || "").length > 0 || this.$t("waiver_sign.email_required"),
                (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val || "") || this.$t("waiver_sign.email_invalid"),
            ];
        },
        phoneRules() {
            return [
                (val) => (val || "").length > 0 || this.$t("waiver_sign.phone_required"),
                (val) => /^\d{3}-\d{3}-\d{4}$/.test(val || "") || this.$t("waiver_sign.phone_invalid"),
            ];
        },
        addressRules() {
            return [
                (val) => (val || "").length > 0 || this.$t("waiver_sign.address_required"),
            ];
        },
        yearRules() {
            const patternYear = /^[0-9]{4}$/;
            return [
                (val) => (val || "").toString().length > 0 || this.$t("waiver_sign.year_required"),
                (val) => !!(val || "").toString().match(patternYear) || this.$t("waiver_sign.year_required")
            ];
        },
        monthRules() {
            return [
                (val) => (val || "").length > 0 || this.$t("waiver_sign.month_required")
            ];
        },
        dayRules() {
            const patternDay = /^[0-9]{2}$/;
            return [
                (val) => (val || "").length > 0 || this.$t("waiver_sign.day_required"),
                (val) => !!(val || "").toString().match(patternDay) || this.$t("waiver_sign.day_required")
            ];
        },
        days() {
            const days31 = ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'];
            const days30 = ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30'];
            const days29 = ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29'];
            if(this.month == '04' || this.month == '06' || this.month == '09' || this.month == '11') {
                return days30;
            } else if(this.month == '02') {
                return days29;
            }
            return days31;
        },
        isConsentRules() {
            return [
                (val) => val || this.$t("waiver_sign.is_consent_required")
            ]
        },
        isCorrectRules() {
            return [
                (val) => val || this.$t("waiver_sign.is_correct_required")
            ]
        },
        isNegligenceRules() {
            return [(val) => val || this.$t("waiver_sign.i_agree_negligence_required")];
        },
        isBoundParticipantRules() {
            return [(val) => val || this.$t("waiver_sign.i_agree_bound_participant_required")];
        },
        isBoundParentRules() {
            return [(val) => val || this.$t("waiver_sign.i_agree_bound_parent_required")];
        },
        effectiveIp() {
            return (this.waiver && this.waiverStatusStatic.includes(this.waiver.waiverStatus))
                ? (this.waiver.ipAddress || "")
                : this.currentIp;
        },
        isLegacySigned() {
            // Post-migration rows carry signedLanguageCode; use it as
            // the explicit schema marker so a new Rejected waiver is
            // not misclassified as legacy.
            return !!(this.waiver
                && ["Signed","Rejected"].includes(this.waiver.waiverStatus)
                && !this.waiver.signedLanguageCode);
        },
        negligenceParagraph() {
            return (this.waiver && this.waiver.negligenceText)
                ? this.waiver.negligenceText
                : this.$t("waiver_sign.negligence_text", this.language);
        },
        boundAgreementParagraph() {
            return (this.waiver && this.waiver.boundAgreementText)
                ? this.waiver.boundAgreementText
                : this.$t("waiver_sign.bound_agreement_text", this.language);
        },
        timeIAgreeLabel() {
            const t = this.timeIAgree ? this.$options.filters.formatDateForHumans(this.timeIAgree) : "";
            const key = this.type === 'Minor' ? "waiver_sign.i_agree_inherent_risks_minor" : "waiver_sign.i_agree_inherent_risks";
            return this.$t(key, this.language, { time: t, ip: this.effectiveIp });
        },
        timeIsCorrectLabel() {
            const t = this.timeIsCorrect ? this.$options.filters.formatDateForHumans(this.timeIsCorrect) : "";
            return this.$t("waiver_sign.is_correct_information", this.language, { time: t, ip: this.effectiveIp });
        },
        timeIsConsentLabel() {
            const t = this.timeIsConsent ? this.$options.filters.formatDateForHumans(this.timeIsConsent) : "";
            return this.$t("waiver_sign.is_consent", this.language, { time: t, ip: this.effectiveIp });
        },
        timeIsNegligenceLabel() {
            const t = this.timeIsNegligence ? this.$options.filters.formatDateForHumans(this.timeIsNegligence) : "";
            const key = this.type === 'Minor' ? "waiver_sign.i_agree_negligence_minor" : "waiver_sign.i_agree_negligence";
            return this.$t(key, this.language, { time: t, ip: this.effectiveIp });
        },
        timeIsBoundParticipantLabel() {
            const t = this.timeIsBoundParticipant ? this.$options.filters.formatDateForHumans(this.timeIsBoundParticipant) : "";
            return this.$t("waiver_sign.i_agree_bound", this.language, { time: t, ip: this.effectiveIp });
        },
        timeIsBoundParentLabel() {
            const t = this.timeIsBoundParent ? this.$options.filters.formatDateForHumans(this.timeIsBoundParent) : "";
            return this.$t("waiver_sign.i_agree_bound", this.language, { time: t, ip: this.effectiveIp });
        },
        language() {
            let language = this.$i18n.locale;
            if(this.waiver && this.waiver.waiversContent && this.waiver.waiversContent[language] && Object.prototype.hasOwnProperty.call(this.waiver.waiversContent[language],'available') && !this.waiver.waiversContent[language].available) {
                language = this.firstContent ? this.firstContent.languageCode : language;
            }
            
            return language;
        },
        firstContent() {
            if(this.waiver && this.waiver.waiversContent) {
                for (const property in this.waiver.waiversContent) {
                    if(this.waiver.waiversContent[property].available)
                        return this.waiver.waiversContent[property]
                }
            }
            return null;
        },
        imageUrl: {
            get() {
                let urlImage = '';
                if((this.urlImage || "").length > 0 && this.urlImage == "error") {
                    return "";
                }
                if(this.waiver && this.waiver.waiversContent[this.language] && this.waiver.waiversContent[this.language].available)
                {
                    urlImage = this.waiver.waiversContent[this.language].headerLogoUrl;
                    return (urlImage || "").length > 0 ? (process.env.VUE_APP_ROOT + this.waiver.waiversContent[this.language].headerLogoUrl) : "";
                }
                if(this.firstContent)
                {
                    urlImage = this.firstContent.headerLogoUrl;
                    return (urlImage || "").length > 0 ? (process.env.VUE_APP_ROOT + this.firstContent.headerLogoUrl) : "";
                }
                return "";  
            },
            set(value) {
                this.urlImage = value;
            }
            
        },
        hasImage() {
            return this.imageUrl && (this.imageUrl || '').length > 0;
        },
        waiverTitle() {
            if(this.waiver && this.waiver.waiversContent) {
                if(this.waiver.waiversContent[this.language] && this.waiver.waiversContent[this.language].available)
                    return this.waiver.waiversContent[this.language].title;
            }
            if(this.firstContent) {
                return this.firstContent.title;
            }
            return "";
        },
        waiverText() {
            if(this.waiver && this.waiver.waiversContent) {
                if(this.waiver.waiversContent[this.language] && this.waiver.waiversContent[this.language].available)
                    return this.waiver.waiversContent[this.language].waiverText;
            }
            if(this.firstContent) {
                return this.firstContent.waiverText;
            }
            return "";
        },
        waiverElectronicConsent() {
            if(this.waiver && this.waiver.waiversContent) {
                if(this.waiver.waiversContent[this.language] && this.waiver.waiversContent[this.language].available)
                    return this.waiver.waiversContent[this.language].waiverElectronicConsent;
            }
            if(this.firstContent) {
                return this.firstContent.waiverElectronicConsent;
            }
            return "";
        }
    },
    methods: {
        formatPhone(value) {
            const numbers = (value || "").replace(/\D/g, "").slice(0, 10);
            if (numbers.length >= 7) return numbers.replace(/(\d{3})(\d{3})(\d{1,4})/, "$1-$2-$3");
            if (numbers.length >= 4) return numbers.replace(/(\d{3})(\d{1,3})/, "$1-$2");
            return numbers;
        },
        onPhoneInput(field, value) {
            this[field] = this.formatPhone(value);
        },
        formatSignatoryAddress(u) {
            if (!u) return "";
            return [u.address, u.city, u.state, u.zip, u.country]
                .filter(x => x && String(x).trim().length > 0)
                .join(", ");
        },
        openAddSignature() {
            this.dialogSignature = true;
        },
        async submit() {
            if(!this.$refs.formWaiver.validate() || !this.signature || (this.waiver.isPictureRequired &&!this.selfie)) {
                if(!this.signature) this.hasErrorSignature =  true;
                if(this.waiver.isPictureRequired && !this.selfie) this.hasErrorSelfie = true;
                if(!this || (this && (!this.$refs.formWaiver.validate() || !this.signature || !this.selfie))) {
                    if(!this.signature) this.hasErrorSignature =  true;
                    if(this.waiver.isPictureRequired && !this.selfie) this.hasErrorSelfie = true;
                    if(this) {
                        let index = "";
                        this.iAgreeRules.forEach((item) => { if(item(this.iAgree) != true) index = "iAgree"; });
                        if(index == "") {
                            if(this.type == 'Adult') {
                                this.firstNameRules.forEach((item) => { if(item(this.firstName) != true) index = "firstName"; });
                            } else {
                                this.firstNameRules.forEach((item) => { if(item(this.firstNameMinor) != true) index = "firstNameMinor"; });
                            }
                        }
                        if(index == "") {
                            if(this.type == 'Adult') {
                                this.lastNameRules.forEach((item) => { if(item(this.lastName) != true) index = "lastName"; });
                            } else {
                                this.lastNameRules.forEach((item) => { if(item(this.lastNameMinor) != true) index = "lastNameMinor"; });
                            }
                        }
                        if(index == "") {
                            if(this.type == 'Adult') {
                                this.genderRules.forEach((item) => { if(item(this.gender) != true) index = "gender"; });
                            } else {
                                this.genderRules.forEach((item) => { if(item(this.genderMinor) != true) index = "genderMinor"; });
                            }
                        }
                        if(index == "") {
                            if(this.type == 'Adult') {
                                this.genderRules.forEach((item) => { if(item(this.gender) != true) index = "gender"; });
                            } else {
                                this.genderRules.forEach((item) => { if(item(this.genderMinor) != true) index = "genderMinor"; });
                            }
                        }
                        if(index == "") {
                            if(this.type == 'Adult') {
                                this.yearRules.forEach((item) => { if(item(this.year) != true) index = "year"; });
                            } else {
                                this.yearRules.forEach((item) => { if(item(this.yearMinor) != true) index = "yearMinor"; });
                            }
                        }
                        if(index == "") {
                            if(this.type == 'Adult') {
                                this.monthRules.forEach((item) => { if(item(this.month) != true) index = "month"; });
                            } else {
                                this.monthRules.forEach((item) => { if(item(this.monthMinor) != true) index = "monthMinor"; });
                            }
                        }
                        if(index == "") {
                            if(this.type == 'Adult') {
                                this.dayRules.forEach((item) => { if(item(this.day) != true) index = "day"; });
                            } else {
                                this.dayRules.forEach((item) => { if(item(this.dayMinor) != true) index = "dayMinor"; });
                            }
                        }
                        if(!this.age18) {
                            if(index == "") {
                                this.firstNameRules.forEach((item) => { if(item(this.firstNameParent) != true) index = "firstNameParent"; });
                            }
                            if(index == "") {
                                this.lastNameRules.forEach((item) => { if(item(this.lastNameParent) != true) index = "lastNameParent"; });
                            }
                            if(index == "") {
                                this.genderRules.forEach((item) => { if(item(this.genderParent) != true) index = "genderParent"; });
                            }
                            if(index == "") {
                                this.yearRules.forEach((item) => { if(item(this.yearParent) != true) index = "yearParent"; });
                            }
                            if(index == "") {
                                this.monthRules.forEach((item) => { if(item(this.monthParent) != true) index = "monthParent"; });
                            }
                            if(index == "") {
                                this.dayRules.forEach((item) => { if(item(this.dayParent) != true) index = "dayParent"; });
                            }
                        }
                        if(index == "") {
                            this.isCorrectRules.forEach((item) => { if(item(this.isCorrect) != true) index = "isCorrect"; });
                        }
                        if(index == "") {
                            if(this.hasErrorSignature) index = "signature";
                        }
                        if(index == "") {
                            this.isConsentRules.forEach((item) => { if(item(this.isConsent) != true) index = "isConsent"; });
                        }
                        if(index != "") {
                            if(index != "signature") {
                                if(this.$refs[index]) this.$refs[index].$refs.input.focus();
                            } else {
                                const element = document.getElementById("signature");
                                if(element) {
                                    element.scrollIntoView({block: "end", behavior: "smooth"});
                                }
                            }
                        }
                    }
                    return;
                }
            }

            let _item =  localStorage.getItem('waiver_promoter');
            _item = _item!= null ? JSON.parse(_item): null;

            const data = new FormData();
            data.append("waiverId", _item.waiver.idWaiver);
            data.append("eventId", _item.event);
            data.append("iAgree", this.timeIAgree);
            data.append("iCertify", this.timeIsCorrect);
            data.append("isConsent", this.timeIsConsent);
            data.append("signature", this.signature);
            data.append("ipAddress", this.currentIp);
            data.append("role", _item.role);
            data.append("firstName", this.age18 ? this.firstName : this.firstNameMinor);
            data.append("lastName", this.age18 ? this.lastName : this.lastNameMinor);
            data.append("gender", this.age18 ? this.gender : this.genderMinor);
            data.append("year", this.age18 ? this.year : this.yearMinor);
            data.append("month", this.age18 ? this.month : this.monthMinor);
            data.append("day", this.age18 ? this.day : this.dayMinor);
            if(!this.age18) {
                data.append("firstNameSignatory", this.firstNameParent);
                data.append("lastNameSignatory", this.lastNameParent);
                data.append("genderSignatory", this.genderParent);
                data.append("yearSignatory", this.yearParent);
                data.append("monthSignatory", this.monthParent);
                data.append("daySignatory", this.dayParent);
            }
            data.append("type", this.age18 ? "Adult" : "Minor");
            data.append("waiverStatus", "Signed");
            if(this.waiver.isPictureRequired) {
                data.append("signatoryPicture", this.selfie);
            }
            data.append("isNegligence", this.timeIsNegligence);
            data.append("isBoundParticipant", this.timeIsBoundParticipant);
            data.append("isBoundParent", this.timeIsBoundParent);
            data.append("isMinor", this.type === 'Minor' ? 1 : 0);
            data.append("languageCode", this.$i18n.locale);
            // Pick signer's own fields vs the parent fields from the
            // authoritative waiver type, not the derived age18 flag.
            const signerIsAdult = this.type === 'Adult';
            data.append("signatoryEmail",   signerIsAdult ? (this.email   || "") : (this.emailParent   || ""));
            data.append("signatoryPhone",   signerIsAdult ? (this.phone   || "") : (this.phoneParent   || ""));
            data.append("signatoryAddress", signerIsAdult ? (this.address || "") : (this.addressParent || ""));
            // Snapshot rendered checkbox/paragraph text exactly as the
            // signer saw it.
            data.append("isAgreedText", this.timeIAgreeLabel || "");
            data.append("isNegligenceText", this.timeIsNegligenceLabel || "");
            data.append("isCertifyText", this.timeIsCorrectLabel || "");
            data.append("isBoundParticipantText", this.timeIsBoundParticipantLabel || "");
            data.append("isBoundParentText", this.timeIsBoundParentLabel || "");
            data.append("isConsentText", this.timeIsConsentLabel || "");
            data.append("voluntarilyText", this.$t("waiver_sign.voluntarily_text", this.language));
            data.append("negligenceText", this.negligenceParagraph || "");
            data.append("boundAgreementText", this.boundAgreementParagraph || "");

            let axiosConfig = {
                headers: { "content-type": "multipart/form-data" },
            };

            const response = await axios.post(`${this.root}/laravel/public/api/v1/promoter/waivers/saveSignature`, data, axiosConfig);
            
            if(response.data.success) {
                this.bandResult = true;
                this.bandReadonly = true;
                this.disabledOptions = true;
                this.disabledSignature = true;
                this.bandReadOnly = true;
            } else {
                if(Array.isArray(response.data.message) && response.data.message.length > 0) {
                    this.snack = true;
                    this.color_snack = "error";
                    this.msg_snack = this.$t("waiver_sign.errors." + response.data.message[0]);
                } else {
                    this.snack = true;
                    this.color_snack = "error";
                    this.msg_snack = this.$t("common.failed_saved");
                }
            }
        },
        getYears() {
            const now = new Date();
            let years = [];
            const init = now.getFullYear() - 100;
            const end = now.getFullYear();
            for(let i = end; i >= init; i--) {
               years.push(i); 
            }
            this.years = years;
        },
        age18Calculate(year, _month, day) {
            const month = _month ? (parseInt(_month) - 1) : null;
            const nowDay = new Date();
            nowDay.setFullYear(nowDay.getFullYear() - 18);
            if(year && month && day) {
                const birthday = new Date(year, month, day);
                return birthday <= nowDay;
            }
            return true;
        },
        changeBandSignature({ value }) {
            this.disabledSignature = value;
        },
        getImage(image) {
            this.errorSignature = !image;
            this.signature = image;
        },
        clearSignature() {
            if(this.$refs.signature)
                this.$refs.signature.cleanCanvas();
        },
        saveSignature() {
            this.$refs.signature.getImage();
            this.timeSignature = this.getTimeStamp();
            this.dialogSignature = false;
        },
        getTimeStamp() {
            const now = new Date(); 
            let month = now.getMonth() + 1;
            month = month < 10 ? `0${month}` : month;
            let day = now.getDate() < 10 ? `0${now.getDate()}` : now.getDate();
            return `${now.getFullYear()}-${month}-${day} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
        },
        changeAge(type = 'Adult') {

            if(type == 'Adult' && this.year && this.month && this.day) {
                this.age18 = this.age18Calculate(this.year, this.month, this.day);
                if(!this.age18) {
                    this.color_snack = "error";
                    this.msg_snack = this.$t("waiver_sign.birthday_invalid");
                    this.snack = true;
                    setTimeout(() => {
                        this.year = this.month = this.day = null;
                    }, 500);
                }
            } else if(type == 'Minor' && this.yearMinor && this.monthMinor && this.dayMinor) {
                this.age18 = this.age18Calculate(this.yearMinor, this.monthMinor, this.dayMinor);
                if(this.age18) {
                    this.color_snack = "error";
                    this.msg_snack = this.$t("waiver_sign.birthday_invalid");
                    this.snack = true;
                    setTimeout(() => {
                        this.yearMinor = this.monthMinor = this.dayMinor = null;
                    }, 500);
                }

            } else if(this.yearParent && this.monthParent && this.dayParent && !this.age18Calculate(this.yearParent, this.monthParent, this.dayParent)){
                this.color_snack = "error";
                this.msg_snack = this.$t("waiver_sign.parent_adult_error");
                this.snack = true;
                setTimeout(() => {
                    this.yearParent = this.monthParent = this.dayParent = null;
                }, 500);
            }

        },
        async getWaiver() {
            let _item =  localStorage.getItem('waiver_promoter');
            _item = _item!= null ? JSON.parse(_item): null;
            if(_item && _item.waiver && _item.waiver.idWaiver) {
                const response = await this.getApi('/api/v1/promoter/waivers/getForId/' + _item.waiver.idWaiver);
                
                if(response.success) {
                    this.waiver = response.message;
                    if(response.message.waiversContent) {
                        this.type = response.message.ageTarget;
                    }
                    const waiver = response.message;
                    if(waiver.isNegligenceChk) {
                        this.isNegligence = true;
                        this.timeIsNegligence = waiver.isNegligenceChk;
                    }
                    if(waiver.isBoundParticipantChk) {
                        this.isBoundParticipant = true;
                        this.timeIsBoundParticipant = waiver.isBoundParticipantChk;
                    }
                    if(waiver.isBoundParentChk) {
                        this.isBoundParent = true;
                        this.timeIsBoundParent = waiver.isBoundParentChk;
                    }
                }
            } else {
                this.snack = true;
                this.color_snack = "error";
                this.msg_snack = this.$t("common.failed_saved");
            }
        },
        async getIP() {
            const response = await this.getApi('/api/v1/users/current/currentIp');

            if(response.success) {
                this.currentIp = response.message;
            }
        },
        async getEvent() {
            let _item =  localStorage.getItem('waiver_promoter');
            _item = _item != null ? JSON.parse(_item): null;
            if(_item && _item.event) {
                
                const response = await this.getApi('/api/v1/promoter/eventDetails/getEvent/' + _item.event);
                
                if(response.success && response.message.length > 0) {
                    this.eventName = response.message[0].eventName;
                    this.eventStartDate = response.message[0].eventDate;
                    this.eventEndDate = response.message[0].eventEndDate;
                }
            } else {
                this.snack = true;
                this.color_snack = "error";
                this.msg_snack = this.$t("common.failed_saved");
            }
        },
        processErrorImg() {
            this.urlImage = "error";
        },
        submitSelfie() {
            if(this.showCam) {
                let video = this.$refs.webcam;
                video.pause();
                var canvas = this.$refs.webcam_canvas;
                canvas.width = 360;
                canvas.height = 480;
                var ctx = canvas.getContext('2d');

                //draw image to canvas. scale to target dimensions
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                //convert to desired file format
                var dataURI = canvas.toDataURL('image/jpeg'); // can also use 'image/png'
                //this.dataURI = dataURI;
                this.uploadSelfie(dataURI);

                video.play();
            } else {
                this.dialogSelfie = false;
            }
        },
        takeSelfie() {
            this.dialogSelfie = true;
            this.bandCropper = false;
            this.showCam = true;
            this.$nextTick(async () => {
                var vidobj = this.$refs.webcam;
                const parent = this;
                
                try {
                    const devices = await navigator.mediaDevices.enumerateDevices();
                    const videoDevices = devices.filter(device => device.kind === 'videoinput');
                    
                    if (videoDevices.length > 0) {
                        const constraints = { video: { deviceId: videoDevices[0].deviceId } };
                        const stream = await navigator.mediaDevices.getUserMedia(constraints);
                        // La cámara está disponible y no está siendo ocupada por otra aplicación
                        vidobj.srcObject = stream;
                        vidobj.play();
                        //stream.getTracks().forEach(track => track.stop());
                    } else {
                        parent.showCam = false;
                    }
                } catch {
                    // Error al acceder a la cámara de video
                    parent.showCam = false;
                }
            });
        },
        loadPlaceholder(e) {
            e.target.src = this.errorImage;
        },
        close() {
            this.imgSrc = null;
            this.cropImg = null;
            this.bandCropper = false;
        },
        uploadSelfie(dataURI) {
            this.imgSrc = dataURI;
            this.uploadCropperImage({ base64Image: this.imgSrc, fileName: 'selfie' });
            this.dialogSelfie = false;
        },
        save(){
            this.cropImage();
            this.uploadCropperImage({ base64Image: this.cropImg, fileName: 'selfie' });
            this.imgSrc = null;
            this.cropImg = null;
            this.dialogSelfie = false;
        },
        cropImage() {
            // get image data for post processing, e.g. upload or setting image src
            this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        },
        uploadCropperImage(data) {
            const { base64Image, fileName } = data;      
            const base64Data = base64Image.replace(/^data:image\/\w+;base64,/, "");
            var byteCharacters = atob(base64Data);

            var byteArray = new Uint8Array(byteCharacters.length);

            for (var i = 0; i < byteCharacters.length; i++) {
                byteArray[i] = byteCharacters.charCodeAt(i);
            }

            var blob = new Blob([byteArray], { type: 'image/png' });

            // Crea un objeto de tipo File a partir del Blob
            var file = new File([blob], 'filename.png', { type: 'image/png' });

            this.uploadImage_ = base64Image;
            this.selfie = base64Image;
            this.fileImage = file;
            this.fileName = fileName;
            //this.uploadImage();
        },
    },
    mounted() {
        this.getYears();
        this.getIP();
        this.getWaiver();
        this.getEvent();
    },
    watch: {
        iAgree(val) {
            if(val) {
                this.timeIAgree = this.getTimeStamp();
            } else {
                this.timeIAgree = "";
            }
        },
        isConsent(val) {
            if(val) {
                this.timeIsConsent = this.getTimeStamp();
            } else {
                this.timeIsConsent = "";
            } 
        },
        dialogSignature(val) {
            if(!val && !this.signature) {
                this.hasErrorSignature = true;
            }
        },
        signature(val) {
            if(val) {
                this.hasErrorSignature = false;
            }
        },
        isCorrect(val) {
            if(val) {
                this.timeIsCorrect = this.getTimeStamp();
            } else {
                this.timeIsCorrect = "";
            }
        },
        selfie(val) {
            if(val) {
                this.hasErrorSelfie = false;
            }
        },
        isNegligence(val) {
            if(this.waiver && this.waiver.waiverStatus != "Signed") {
                if(val && this.waiver.isNegligenceChk) return;
                this.timeIsNegligence = val ? this.getTimeStamp() : "";
            }
        },
        isBoundParticipant(val) {
            if(this.waiver && this.waiver.waiverStatus != "Signed") {
                if(val && this.waiver.isBoundParticipantChk) return;
                this.timeIsBoundParticipant = val ? this.getTimeStamp() : "";
            }
        },
        isBoundParent(val) {
            if(this.waiver && this.waiver.waiverStatus != "Signed") {
                if(val && this.waiver.isBoundParentChk) return;
                this.timeIsBoundParent = val ? this.getTimeStamp() : "";
            }
        },
    }
}
</script>

<style lang="scss">
#waiverSignForm {
    .headerTitle {
        .v-image {
            max-height: 130px;

            .v-image__image {
                background-size: contain;
            }
        }
        h1 {
            margin: auto 0 auto 1rem;
            font-weight: 300;
            font-size: 3.75rem;
        }
    }
    .errorSignature , .errorSelfie {
        border-color: var(--v-error-base) !important;
        .v-divider {
            border-color: var(--v-error-base) !important;
        }
    }
    .textErrorSignature, .textErrorSelfie {
        color: var(--v-error-base) !important;
    }
    .cont-inp-promo {
        min-width: 250px; 
        width: 100%; 
        max-width: 300px; 
        margin-left: auto; 
        margin-right: 10px;
    }
    .cont-btn-promo {
        min-width: 200px; 
        width: 100%; 
        max-width: 200px;
    }
    .checkSummary {
        margin: 0;
        padding: 0;
        .v-input__control {
            margin: 0;
            padding: 0;
            .v-input__slot {
                margin: 0;
            }
        }
        .v-messages {
            min-height: 0;
        }
    }
    .containImg {
        padding: 4px;
        border-radius: 4px 4px 0 0;
        border: 1px solid #ddd;
        background-color: white;
        padding-bottom: 20px;
        max-width: 250px;
        /*margin: 0 auto;*/
    }
    .imgAvatar { max-width: 100%; object-fit: contain; }
    .btnAvatar { max-width: 250px; width: 100%; }
}
.forgotPasswordModal {
    .v-application--wrap {
        min-height: 0 !important;
    }
}
.msgBigAlert {
    .v-alert__wrapper {
        display: block;
        .v-icon {
            width: 100%;
            margin-top: 20px;
            margin-bottom: 20px;
        }
        .v-alert__content {
            margin-top: 20px;
            margin-bottom: 20px;
        }
    }
}
.waiverTitle{
    text-align: left;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: 2em;
    text-transform: uppercase;
    line-height: 1.2;
}
.waiverScroll {
    height: 100%;
    overflow-y: auto;
}
.heigthLimit {
  max-height: 211px !important;
}
@media (min-width: 1024px) and (max-width: 1263px) {
    .waiverTitle{
        font-size: 1.8em;
    }
}
@media (min-width: 700px) and (max-width: 1023px) {
    .waiverTitle{
        font-size: 1.5em;
    }
}
@media (max-width: 699px) {
    .waiverTitle{
        font-size: 1.3em;
    }
}
@media print {
    .pagebreak{ page-break-before: always; } 
    .printSpace{ max-width: 100% ; flex: auto; } 
}
.cropper-area { width: 614px; }
.actions { margin-top: 1rem; }
.actions a { 
    display: inline-block; padding: 5px 15px; background: #0062CC; color: white; text-decoration: none; border-radius: 3px;
    margin-right: 1rem; margin-bottom: 1rem;
}
.preview-area { width: 307px; }
.preview-area p { font-size: 1.25rem; margin: 0; margin-bottom: 1rem; margin-left: 1rem;}
.preview-area p:last-of-type { margin-top: 1rem; }
.preview { width: 100%; height: calc(372px * (9 / 16)); overflow: hidden; margin-left: 10px; }
.crop-placeholder { width: 100%; height: 200px; background: #ccc; }
.cropped-image img { max-width: 100%; }
</style>
